export default [
	{
		dataIndex: 'priority',
		key: 'priority',
		title: 'Priority',
		scopedSlots: {customRender: 'priority'}
	}, {
		key: 'biller',
		title: 'Biller',
		scopedSlots: {customRender: 'biller'}
	}, {
		dataIndex: 'product_code',
		key: 'productCode',
		title: 'Product Code',
		scopedSlots: {customRender: 'productCode'}
	}, {
		dataIndex: 'class_schema',
		key: 'classSchema',
		title: 'Class Schema',
		scopedSlots: {customRender: 'classSchema'},
	}, {
		dataIndex: 'price_scheme',
		key: 'priceScheme',
		title: 'Price Scheme',
		scopedSlots: {customRender: 'priceScheme'}
	}, {
		dataIndex: 'base_price',
		key: 'basePrice',
		title: 'Base Price',
		scopedSlots: {customRender: 'basePrice'}
	}, {
		dataIndex: 'admin_fee',
		key: 'adminFee',
		title: 'Admin Fee',
		scopedSlots: {customRender: 'adminFee'}
	}, {
		dataIndex: 'share_fee',
		key: 'shareFee',
		title: 'Share Fee',
		scopedSlots: {customRender: 'shareFee'}
	}, {
		key: 'profitable',
		title: 'Profitable',
		width: 150,
		align: 'center',
		scopedSlots: {customRender: 'profitable'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 150,
		scopedSlots: {customRender: 'action'}
	}
]
